import create from "zustand";
import { persist } from "zustand/middleware";

interface SettingPrefState {
  dark: boolean;
  entity: string | null;
  counterparties: string[] | null;
  setEntity: (entity: string | null) => void;
  setCounterparties: (counterparties: string[] | null) => void;
  setDark: (dark: boolean) => void;
  savedEmail: string | null;
  setSavedEmail: (savedEmail: string | null) => void;
}

const useSettingPrefStore = create<SettingPrefState>()(
  persist(
    (set) => ({
      dark: false,
      entity: null,
      counterparties: null,
      savedEmail: null,
      setEntity: (entity) => set(() => ({ entity })),
      setCounterparties: (counterparties) => set(() => ({ counterparties })),
      setDark: (dark) => set(() => ({ dark })),
      setSavedEmail: (savedEmail: string | null) => set(() => ({ savedEmail })),
    }),
    {
      name: "settings-pref",
    }
  )
);

export default useSettingPrefStore;
